


















import { ResizeObserver as ResizeObserverPolyfill, ResizeObserverEntry } from '@juggle/resize-observer';

import { ICarouselSlide } from '../models/components/i-carousel';

let JS_INTERVAL_REF;
const START_SLIDE_INDEX = 0;

export default {
  name: 'carousel',
  props: {
    slides: {
      type: Array, // ICarouselSlide
      required: true
    },
    interval: {
      type: Number,
      default: 7000
    },
    autoplay: {
      type: Boolean,
      default: true
    }
  },
  data: function () {
    return {
      baseClass: 'epb-carousel',
      slideWidth: 0
    };
  },
  computed: {
    activeSlideIndex: function (): number {
      return this.slides.findIndex((slide: ICarouselSlide): boolean => slide.active);
    },
    nextSlideIndex: function (): number {
      return this.activeSlideIndex < this.slides.length - 1 ? this.activeSlideIndex + 1 : START_SLIDE_INDEX;
    },
    previousSlideIndex: function (): number {
      return this.activeSlideIndex === START_SLIDE_INDEX ? this.slides.length - 1 : this.activeSlideIndex - 1;
    }
  },
  methods: {
    slideToIndex: function (slideIndex: number): void {
      this.slides.forEach((slide: ICarouselSlide, index: number): void => {
        slide.active = index === slideIndex;
      });
      const container = this.$refs.container;
      container.scrollTo({ left: slideIndex * this.slideWidth });
    },
    handleSlideClick: function (slideIndex: number): void {
      clearInterval(JS_INTERVAL_REF);
      this.slideToIndex(slideIndex);
      this.$emit('slideUpdated', slideIndex);
    }
  },
  mounted: function (): void {
    this.slides[START_SLIDE_INDEX].active = true;
    if (!!this.autoplay) {
      JS_INTERVAL_REF = setInterval(() => {
        this.slideToIndex(this.nextSlideIndex);
      }, this.interval);
    }
    const ResizeObserver = (window['ResizeObserver'] || ResizeObserverPolyfill);
    this.resizeObserver = new ResizeObserver((rootEntry: ResizeObserverEntry[]) => {
      const rootElement = rootEntry[0].target as HTMLElement;
      this.slideWidth = rootElement.getBoundingClientRect().width;
    });
    this.resizeObserver.observe(this.$el);
  },
  beforeDestroy: function (): void {
    this.slides.forEach((slide: ICarouselSlide) => slide.active = false);
    clearInterval(JS_INTERVAL_REF);
  }
};

